import DashboardStockoutByProductPanel from "./dashboardStockoutByProductPanel.container"

export default DashboardStockoutByProductPanel
